import api from '../config/api';

const configuracionDescansoLaboradoService = {
  async obtenerConfiguracion(empresaId) {
    try {
      const response = await api.get(`/configuracion-descanso-laborado/empresa/${empresaId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener configuración de descanso laborado:', error);
      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }
      return {
        success: false,
        error: error.response?.data?.error || 'Error al obtener configuración de descanso laborado',
      };
    }
  },

  async actualizarConfiguracion(empresaId, { pago_doble }) {
    try {
      const response = await api.put(`/configuracion-descanso-laborado/empresa/${empresaId}`, {
        pago_doble: Boolean(pago_doble),
      });
      return response.data;
    } catch (error) {
      console.error('Error al actualizar configuración de descanso laborado:', error);
      if (error.response?.status === 422) {
        return {
          success: false,
          error: 'Datos de entrada inválidos',
          details: error.response.data.details,
        };
      }
      return {
        success: false,
        error: error.response?.data?.error || 'Error al actualizar configuración de descanso laborado',
      };
    }
  },
};

export default configuracionDescansoLaboradoService;
